<template>
  <z-dialogo
    ref="dialogoLancamento"
    :titulo="`${titulo} ${isPago ? '(Pago)' : ''}`"
    largura="700px"
    eager
    persistent
    :dividers="true"ß
  >
    <template v-slot:texto>
      <v-form ref="form" v-model="form_valido" lazy-validation>
        <v-row dense>
          <v-col cols="12" sm="8">
            <v-text-field
              v-model="contapagar.documento"
              ref="descricao"
              label="Descrição/Documento"
              autofocus
              filled
              dense
              :disabled="isPago || isPagando"
              :rules="regras.descricao"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="4" v-if="!isPagando">
            <z-campo-valor
              v-model="contapagar.valor"
              label="Valor"
              ref="valor"
              dense
              :disabled="isPago"
              :rules="regras.valor"
            ></z-campo-valor>
          </v-col>

          <!-- <v-col cols="12" sm="4" v-if="isPago || isPagando">
            <z-campo-valor
              v-model="contapagar.valor_pago"
              :label="isPagando ? 'Valor' : 'Valor Pago'"
              ref="valor"
              dense
              :disabled="isPago"
              :rules="regras.valor"
            ></z-campo-valor>
          </v-col> -->

          <v-col cols="12" sm="4">
            <z-date-picker-menu
              v-model="contapagar.vencimento"
              label="Data Vencimento"
              dense
              :disabled="isPago || isPagando"
            ></z-date-picker-menu>
          </v-col>

          <v-col cols="12" sm="4" v-if="contapagar.pago">
            <z-date-picker-menu
              v-model="contapagar.data_pagamento"
              label="Data Pagamento"
              dense
              :disabled="isPago"
            ></z-date-picker-menu>
          </v-col>

          <v-col cols="12" sm="4">
            <v-autocomplete
              v-model="contapagar.categoria_id"
              dense
              label="Categoria"
              filled
              :disabled="isPago"
              :items="listasStore.contas_pagar_categorias"
              :rules="regras.obrigatorio"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="4">
            <v-select
              v-model="contapagar.forma_pagamento"
              label="Forma de Pagamento"
              filled
              dense
              :disabled="isPago"
              :items="$globals.FORMAS_DE_PAGAMENTO_CAIXA"
            ></v-select>
          </v-col>

          <!-- <v-col cols="12" sm="4" v-if="!isCriando">
            <v-select
              v-model="contapagar.pago"
              label="Pago"
              filled
              dense
              :items="[
                { text: 'Sim', value: 1 },
                { text: 'Não', value: 0 }
              ]"
            ></v-select>
          </v-col> -->

          <v-col cols="12" :sm="isPago ? 8 : 12">
            <v-autocomplete
              v-model="contapagar.fornecedor_id"
              dense
              label="Fornecedor"
              filled
              clearable
              rules_="regras.obrigatorio"
              :disabled="isPago"
              :items="listasStore.fornecedores"
            ></v-autocomplete>
          </v-col>

          <v-row dense v-if="isCriando">
            <v-col cols="12" sm="4">
              <v-select
                v-model="contapagar.dividir_parcelar"
                label="Repetir/Dividir"
                filled
                dense
                :items="['Não','Repetir', 'Dividir']"
                @change="() => { if (contapagar.dividir_parcelar === 'Não') contapagar.parcelas = 1; }"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4">
              <z-text-field
                v-model="contapagar.parcelas"
                label="Parcelas"
                type="number"
                min="1"
                step="1"
                dense
                :hint="parcelado"
                persistent-hint
                :disabled="contapagar.dividir_parcelar === 'Não'"
              ></z-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <z-select
                v-model="contapagar.recorrencia"
                label="Recorrência"
                dense
                :items="['Semanal', 'Quinzenal', 'Mensal', 'Bimestral', 'Trimestral', 'Semestral', 'Anual']"
                :disabled="contapagar.dividir_parcelar === 'Não'"
              ></z-select>
            </v-col>


          </v-row>

        </v-row>

      </v-form>
    </template>


    <template #actions_left>
      <!-- <v-switch 
        v-if="!isCriando"
        v-model="contapagar.pago" 
        class="my-0 shrink" 
        color="primary" 
        label="Pago"
        :true-value="1"
        :false-value="0"
        hide-details 
      ></v-switch> -->

    </template>
    
    <template #actions_right>
      <v-btn text @click="fechar" :disabled="salvando">Fechar</v-btn>

      <v-btn 
        v-if="isPago"
        color="red"
        dark
        depressed 
        :disabled="salvando"
        @click="cancelarPagamento" 
      >Cancelar pagamento</v-btn>

      <v-btn
        v-else
        color="primary"
        depressed
        :loading="salvando"
        :disabled="salvando || !form_valido"
        @click="confirmarLancamento"
      >{{ textoSalvar }}</v-btn>
      
    </template>

  </z-dialogo>
</template>

<script setup>
import { ref, computed, inject } from 'vue';
import queryBuilder from '@/app/helpers/QueryBuilder';
import { useContasPagarStore } from '@/app/store/pinia/contaspagar.js';
import { useListasStore } from '@/app/store/pinia/listas.js';
import { valorBR } from '@/app/helpers/formatacoes.js';

const props = defineProps({
  titulo: {
    type: String,
    default: "Lançamento de Conta a Pagar"
  },
  operacao: {
    type: String,
    default: "criando" // pode ser "criando", "pagando" ou "editando"
  }
});

const emits = defineEmits(['onSave']);

const $notificacao = inject('notificacao');

const contasPagarStore = useContasPagarStore();
const listasStore = useListasStore();

const dialogoLancamento = ref(null);

const isCriando = computed(() => props.operacao === "criando");
const isPagando = computed(() => props.operacao === "pagando");
const isEditando = computed(() => props.operacao === "editando");
const isPago = computed(() => contapagar.value.pago == 1);

const salvando = ref(false);
const form_valido = ref(false);
const form = ref(null);

const textoSalvar = computed(() => {
  if (isCriando.value) return "Salvar";
  if (isPagando.value) return "Pagar";
  return "Salvar";
});

const regras = {
  descricao: [(v) => !!v || "O campo descrição é obrigatório"],
  valor: [(v) => v != "0,00" || "O campo valor não pode ser zero"],
  forma_pagamento: [
    (v) => !!v || "O campo forma de pagamento é obrigatório",
  ],
  obrigatorio: [v => !!v || "Campo obrigatório"]
};

const contapagar = computed(() => {
  return contasPagarStore.contapagar;
});

const parcelado = computed(() => {
  if (contapagar.value.valor === 0 || contapagar.value.parcelas < 1) {
    return "";
  }

  if (contapagar.value.dividir_parcelar === "Repetir") {
    return `${contapagar.value.parcelas}x de R$ ${valorBR(contapagar.value.valor)}` ;
  } else if (contapagar.value.dividir_parcelar === "Dividir") {
    return `${contapagar.value.parcelas}x de R$ ${valorBR(contapagar.value.valor / contapagar.value.parcelas)}`;
  } else {
    return `1x de R$ ${valorBR(contapagar.value.valor)}`;
  }
});

const getListas = async () => {
  await listasStore.fetchListas([
    queryBuilder()
      .from("ContaPagarCategoria")
      .selectraw("id as value, descricao as text, tipo")
      .orderBy("descricao")
      .where("tipo='Despesa'")
      .build(),
    queryBuilder()
      .from("Fornecedor")
      .selectraw("id as value, razao as text")
      .orderBy("razao")
      .build()
  ]);
};


async function confirmarLancamento() {

  if (form.value.validate()) {
    salvando.value = true;
    try {

      if (contapagar.value.id) {
        await contasPagarStore.atualizar(contapagar.value);
      } else {
        await contasPagarStore.salvar(contapagar.value);
      }
      
      // await contasPagarStore.listar({})
      dialogoLancamento.value.fechar();
      $notificacao.notificar("Lançamento salvo com sucesso!");
      emits('onSave', contapagar.value);
    } catch (error) {
      // $notificacao.error("Não foi possível salvar o lançamento.", error);
      throw error;
    } finally {
      salvando.value = false;
    }
  }
}

async function cancelarPagamento() {

    salvando.value = true;
    try {

      contapagar.value.pago = 0;
      contapagar.value.data_pagamento = null;
      contapagar.value.valor_pago = 0;

      await contasPagarStore.atualizar(contapagar.value);
      
      // await contasPagarStore.listar({})
      dialogoLancamento.value.fechar();
      $notificacao.notificar("Pagamento cancelado com sucesso!");
      emits('onSave', contapagar.value);
    } catch (error) {
      // $notificacao.error("Não foi possível salvar o lançamento.", error);
      throw error;
    } finally {
      salvando.value = false;
    }
}

async function abrir() {
  form.value.resetValidation();
  await getListas();
  dialogoLancamento.value.abrir();
}

function fechar() {
  // form.value.resetValidation();
  dialogoLancamento.value.fechar();
}

defineExpose({
  abrir,
  fechar
});

</script>

<style lang="scss" scoped>

</style>